import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { fetchFromApi } from '../../config/api';
import API_ENDPOINTS from '../../config/apiConfig';
import { useData } from '../../context/DataContext';

function AddCategoriesModel(props) {
    const { fetchCategoriesData } = useData();
    const [category, setCategory] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!category.trim()) { setError("Category name cannot be empty"); return; }
        setLoading(true);
        setError("");
        try {
            const data = await fetchFromApi(API_ENDPOINTS.CATEGORIES_ADDING, 'POST', { category_name: category.trim() });
            if (data.status === "success") {
                setSuccessMsg("Category added successfully!");
                setTimeout(async () => {
                    setCategory(""); setSuccessMsg(""); props.onHide(); await fetchCategoriesData();
                }, 1500);
            } else {
                setError("Failed to add category. Please try again.");
            }
        } catch {
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal {...props} size="sm" centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="form-field">
                        <label htmlFor="cat-name">Category Name <span className="req">*</span></label>
                        <input
                            id="cat-name"
                            type="text"
                            placeholder="e.g. Abstract, Portrait…"
                            value={category}
                            onChange={(e) => { setCategory(e.target.value); setError(""); }}
                            className={error ? 'is-error' : ''}
                            disabled={loading}
                            autoFocus
                        />
                        {error && <span className="field-error">{error}</span>}
                    </div>
                    {successMsg && (
                        <div className="modal-alert success">
                            <i className="fa-solid fa-circle-check"></i> {successMsg}
                        </div>
                    )}
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn-primary-orange" onClick={handleSubmit} disabled={loading}>
                    {loading ? "Adding…" : "Add Category"}
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddCategoriesModel;
